/**
 * Lightweight client-side search inside a single facet (list-filter).
 * Toggles `.filter-search-hidden` on `<li data-search-label="...">` items
 * whose label does not include the typed query.
 *
 * Activated via `<input data-filter-search-input data-target-list="..."> `
 * rendered by `snippets/list-filter.liquid` when a facet has many values.
 */

const HIDDEN_CLASS = "filter-search-hidden";
const NO_RESULTS_CLASS = "facets__filter-search-empty";

function normalize(s) {
  return (s || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

function applyFilter(input) {
  const listId = input.dataset.targetList;
  if (!listId) return;
  const list = document.getElementById(listId);
  if (!list) return;

  const q = normalize(input.value.trim());
  const items = list.querySelectorAll("li[data-search-label]");
  let visible = 0;
  for (const li of items) {
    const label = normalize(li.dataset.searchLabel);
    const match = q === "" || label.includes(q);
    li.classList.toggle(HIDDEN_CLASS, !match);
    if (match) visible++;
  }

  // Reveal collapsed items (show-more) so users can find them through search.
  if (q !== "") {
    for (const li of items) {
      if (li.classList.contains("hidden")) li.dataset.searchHidShowMore = "1";
      li.classList.remove("hidden");
      li.classList.remove("mobile:hidden");
    }
  } else {
    for (const li of items) {
      if (li.dataset.searchHidShowMore === "1") {
        li.classList.add("hidden");
        delete li.dataset.searchHidShowMore;
      }
    }
  }

  // Toggle "no results" state on the wrapper.
  const wrapper = input.closest("[data-filter-search]");
  if (wrapper) wrapper.classList.toggle(NO_RESULTS_CLASS, visible === 0 && q !== "");
}

function bind(root = document) {
  const inputs = root.querySelectorAll("[data-filter-search-input]:not([data-bound])");
  for (const input of inputs) {
    input.dataset.bound = "1";
    input.addEventListener("input", () => applyFilter(input));
    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        input.value = "";
        applyFilter(input);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => bind(document));

// Re-bind after AJAX section re-renders (Shopify Horizon emits this).
document.addEventListener("section:rendered", (e) => bind(e.target || document));
document.addEventListener("collection:updated", () => bind(document));

// Fallback: observe the DOM for new search inputs added by section updates.
if (typeof MutationObserver !== "undefined") {
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) bind(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
